import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../AuthContext'
import { FullScreenSpinner } from './FullScreenSpinner'

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth()
  if (isLoading) return <FullScreenSpinner />
  if (!user) return <Navigate to="/login" replace />
  return <>{children}</>
}

// Gatea /admin/* — SuperAdmin de plataforma (User.is_admin), nada que ver con
// ser owner de una Sociedad puntual.
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  if (!user?.is_admin) return <Navigate to="/app" replace />
  return <>{children}</>
}

// Gatea pantallas de /app/* que solo el Dueño de la Sociedad ACTIVA puede ver
// (Contexto del chatbot, transferir titularidad) — un Administrador u Operador
// cae a Conversaciones, no a un error.
export function RequireOwner({ children }: { children: ReactNode }) {
  const { user, activeSociedadId } = useAuth()
  const membership = user?.sociedades.find((s) => s.id === activeSociedadId)
  if (membership?.rank !== 'owner') return <Navigate to="/app/conversaciones" replace />
  return <>{children}</>
}

// Gatea pantallas de /app/* que Dueño y Administrador pueden ver (números de
// WhatsApp, base de conocimiento, miembros, configuración de Sociedad) — un
// Operador cae a Conversaciones, no a un error.
export function RequireAdministrador({ children }: { children: ReactNode }) {
  const { user, activeSociedadId } = useAuth()
  const membership = user?.sociedades.find((s) => s.id === activeSociedadId)
  if (membership?.rank === 'operador' || !membership) return <Navigate to="/app/conversaciones" replace />
  return <>{children}</>
}

// Destino de "/" y de cualquier ruta que no matcheó — decide entre /admin y
// /app según el tipo de cuenta, en vez de asumir que todos tienen Sociedad.
export function RootRedirect() {
  const { user, isLoading, activeSociedadId } = useAuth()
  if (isLoading) return <FullScreenSpinner />
  if (!user) return <Navigate to="/login" replace />
  if (user.is_admin && !activeSociedadId) return <Navigate to="/admin" replace />
  return <Navigate to="/app/conversaciones" replace />
}
